var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPzbz = function SvgPzbz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.316.76c-1.773-.621-2.934.01-3.524.517l-.004.006-1.075 1.101-2.832 2.9a.422.422 0 0 1-.604 0 .446.446 0 0 1 0-.62l3.128-3.202C5.902.948 4.683.058 2.684.758c-1.525.669-4.7 3.79-.855 7.653 3.845 3.863 5.056 4.956 5.056 4.956l.117.133.116-.133s1.21-1.093 5.056-4.956c3.841-3.862.665-6.982-.858-7.651Z",
    fill: "#fff"
  })));
};

export default SvgPzbz;